// Importaciones necesarias
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // <--- 1. IMPORTAR ActivatedRoute
import { ChromadbService } from '../../services/chromadb.service';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

// (Las interfaces no cambian)
interface Search {
  query: string
  limit: number
  matches: Matches[]
}
interface Matches {
  id: number
  distance: number
  document: string
  metadata: metadata
}
interface metadata {
  counter: number
  timestamp: string
}

@Component({
  selector: 'app-search',
  standalone: true, // Asumo que es standalone por el 'imports' en @Component
  imports: [NgFor, FormsModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SearchComponent implements OnInit {

  public collectionName: string | null = null;
  public search: Search = {
    query: "",
    limit: 10,
    matches: []
  };

  // 2. INYECTAR ActivatedRoute en el constructor
  constructor(
    private chromadb: ChromadbService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // 3. SUSCRIBIRSE a los parámetros de la URL
    this.route.queryParamMap.subscribe(queryParams => {
      // Obtenemos los parámetros GET (query parameters)
      const query = queryParams.get('query'); // <-- El parámetro ?query=...
      const limit = queryParams.get('limit');   // <-- El parámetro &limit=...

      // También obtenemos el nombre de la colección de la ruta (forma correcta)
      // Asumiendo que tu ruta es algo como '/search/:collectionName'
      this.collectionName = this.route.snapshot.paramMap.get('collection');

      // Nos aseguramos de que los parámetros existen antes de llamar al servicio
      if (this.collectionName && query && limit) {
        console.log(`Buscando en '${this.collectionName}' con query='${query}' y limit='${limit}'`);
        this.search.query = query
        
        // Llamamos al servicio con los valores obtenidos de la URL
        this.chromadb.searchCollection(this.collectionName, query, Number(limit)).subscribe({
          next: (data: any) => {
            this.search.matches = data;
            console.log(this.search.matches.length + ' results shown');
          },
          error: (error: any) => {
            console.log(error);
          }
        });
      } else {
        console.error('Faltan parámetros en la URL: collectionName, query o limit.');
      }
    });
  }

  public searchCollection(): void {
    this.router.navigate(['/search', this.collectionName], {
      queryParams: {
        query: this.search.query,
        limit: this.search.limit
      }
    });
  }

}
